<template>
  <div>
    <headers :tabIndex="1"></headers>
    <div class="contactUs-banner">
        <div class="news-title">携手交达 共创未来</div>
      <div class="news-detail">交达在公路、铁路、市政、水利、矿山、地产等基建行业，提供特色检（监）测、特殊试验、科研项目、产品研发、技术咨询、数据服务、技术培训等类型的相关业务</div>
    </div>

    <div class="contactUs-box1">
        <p class="box1-title">联系我们</p>
        <div class="box-content">
          <div class="p1">合作热线</div>
          <div class="flex p2"><i class="iconfont icon-a-Contactus-phone flex-center" style="color: rgba(0, 113, 239, 1);margin-right: 0.2rem"></i><span>023-62296708</span></div>
        </div>
    </div>
    <div class="contactUs-box2">
        <div class="box2-li flex">
          <div class="li-left"></div>
          <div class="li-right">
            <span class="t1"><i class="iconfont icon-a-Contactus-Address" style="color: rgba(0, 113, 239, 1);margin-right: 0.2rem"></i>地址</span>
            <span class="line"></span>
            <span class="t2">重庆市渝北区杨柳路2号B区3楼</span>
          </div>
        </div>
        <div class="box2-li flex">
          <div class="li-left"></div>
          <div class="li-right">
            <span class="t1">
              <i class="iconfont icon-a-Contactus-Website" style="color: rgba(0, 113, 239, 1);margin-right: 0.2rem"></i>
              网址</span>
            <span class="line"></span>
            <a href="https://www.scjdst.com/" class="t2">www.scjdst.com</a>
          </div>
        </div>
        <div class="box2-li flex">
          <div class="li-left"></div>
          <div class="li-right">
            <span class="t1"><i class="iconfont icon-a-Contactus-email" style="color: rgba(0, 113, 239, 1);margin-right: 0.2rem"></i>邮编</span>
            <span class="line"></span>
            <span class="t2">401120</span>
          </div>
        </div>
    </div>
    <div id="allmap" style="height: 8rem;margin-top: 1rem;margin-bottom: 0.4rem"></div>
    <footers></footers>
  </div>
</template>


<script>
  import headers from "@/components/wap/header1"
  import footers from "@/components/wap/footer"
  import axios from "axios";
  export default {
    name: 'wapContactUs',
    components:{headers,footers},
    data() {
      return{
      }
    },
    mounted() {
      var map = new BMapGL.Map("allmap");
      let icons= 'https://www.scjdst.com/map.png'
      map.centerAndZoom(new BMapGL.Point(106.503294,29.62063), 16);
      var pt = new BMapGL.Point(106.503323,29.620032);
      var myIcon = new BMapGL.Icon(icons,new BMapGL.Size(80, 80));
      var AMarkerList = new BMapGL.Marker(pt, {
        icon: myIcon
      });
      map.enableScrollWheelZoom(true);
      map.addOverlay(AMarkerList);
    },
    beforeDestroy() {
    },
    methods:{
    }
  }
</script>

<style scoped>
  .contactUs-banner{
    width: 100%;
    height: 13.34rem;
    padding-top: 1rem;
    background-image: url("../../assets/imgs/wap/8.png");
    background-size: cover;
  }
  .contactUs-banner .news-title{
    font-size: 0.48rem;
    font-family: PingFang SC-Heavy, PingFang SC;
    font-weight: 800;
    color: #19203B;
    margin-top: 1.34rem;
    animation-name: fadeInUp;
    padding:0 0.68rem;
    animation-duration:1s;
    animation-timing-function:ease;
  }
  .contactUs-banner .news-detail{
    width: 5.88rem;
    margin: 0.8rem 0;
    animation-name: fadeInUp;
    padding:0 0.68rem;
    animation-duration:1s;
    animation-delay: 1s;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
    opacity: 0;
    line-height: 2;
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #19203B;
  }
  .contactUs-box1{
    padding: 0.4rem 0.72rem;
  }
  .contactUs-box2{
    padding: 0 0.72rem;
  }
  .contactUs-box1 .box1-title{
    font-size: 0.48rem;
    margin-bottom: 0.2rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }
  .contactUs-box1 .p1{
    font-size: 0.4rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    margin-bottom: 0.2rem;
    color: #19203B;
    margin-top: 0.4rem;
  }
  .contactUs-box1 .p2{
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }
  .contactUs-box2 span{
    display: block;
  }
  .contactUs-box2 .li-right{
    margin-top: 0.2rem;
  }
  .contactUs-box2 .t1{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }
  .contactUs-box2 .line{
    width: 5.48rem;
    height: 0.02rem;
    margin: 0.2rem 0 0.2rem 0.54rem;
    background: #19203B;
  }
  .contactUs-box2 .t2{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    margin-left: 0.54rem;
    margin-top: 0.2rem;
    display: block;
    margin-bottom: 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/contactUs/wapIndex.vue